import { createAction } from '@reduxjs/toolkit';

export const splashScreenUpdateId = createAction('splashScreen/updateId');
export const splashScreenUpdateIsAdded = createAction('splashScreen/updateIsAdded');
export const splashScreenUpdateIsActive = createAction('splashScreen/updateIsActive');

export const splashScreenStore = createAction('splashScreen/store');
export const splashScreenClear = createAction('splashScreen/clear');

export const splashScreenUpdateRequest = createAction('splashScreen/updateRequest');
export const splashScreenUpdateError = createAction('splashScreen/updateError');
export const splashScreenUpdateStore = createAction('splashScreen/updateStore');

export const splashScreenUpdateActionType = createAction('splashScreen/updateActionType');
export const splashScreenUpdateButtonTitle = createAction('splashScreen/updateButtonTitle');
export const splashScreenUpdateButtonUrl = createAction('splashScreen/updateButtonUrl');

export const splashScreenUpdateTitle = createAction('splashScreen/updateTitle');
export const splashScreenUpdateDescription = createAction('splashScreen/updateDescription');
export const splashScreenUpdateMediaUrl = createAction('splashScreen/updateMediaUrl');
export const splashScreenUpdateSectionType = createAction('splashScreen/updateSectionType');

export const splashScreenUpdateProductSelect = createAction('splashScreen/updateProductSelect');
export const splashScreenUpdateProductId = createAction('splashScreen/updateProductId');

export const splashScreenUpdateCTAActionType = createAction('splashScreen/updateCTAActionType');
export const splashScreenUpdateCTASite = createAction('splashScreen/updateCTASite');
export const splashScreenUpdateCTASiteText = createAction('splashScreen/updateCTASiteText');
export const splashScreenUpdateCTABackgroundColor = createAction('splashScreen/updateCTABackgroundColor');
export const splashScreenUpdateCTABackgroundColorRGBA = createAction('splashScreen/updateCTABackgroundColorRGBA');
export const splashScreenUpdateCTATextColor = createAction('splashScreen/updateCTATextColor');
export const splashScreenUpdateCTAIsBorder = createAction('splashScreen/updateCTAIsBorder');
export const splashScreenUpdateCTAOpacity = createAction('splashScreen/updateCTAOpacity');
export const splashScreenUpdateCTAItemId = createAction('splashScreen/updateCTAItemId');
export const splashScreenUpdateCTABlockId = createAction('splashScreen/updateCTABlockId');
export const splashScreenUpdateCTAPageId = createAction('splashScreen/updateCTAPageId');
